"use client";

import { createContext } from "react";
import { StrapiComponentType } from "@/src/type";
import { GrowthBookType } from "@/src/type/growthbook";

export const DEFAULT_HEADER: StrapiComponentType.Partial.Header = {
  flowLogo: "light",
  bottomShadow: false,
  darkMenuIcon: false,
  blurBackground: false,
  navOff: false,
  logoOff: false,
  inheritBackgroundColorOff: false,
};

export const STATIC_PAGE_HEADER: StrapiComponentType.Partial.Header = {
  flowLogo: "dark",
  bottomShadow: false,
  darkMenuIcon: true,
  blurBackground: false,
  navOff: false,
  logoOff: false,
  inheritBackgroundColorOff: false,
};

export interface AppContextType {
  defaultQuery: string;
  profile?: any;
  header: StrapiComponentType.Partial.Header;
  backgroundColor?: string;
  defaultDomain: string;
  pageSliderData: {
    activeIndex?: number;
  };
  growthBook: GrowthBookType.GrowthBookAndContentVariants;
  setProfile: (firstName: string, imageProfileUrl: string) => void;
  setProfileImageUrl: (imageProfileUrl: string) => void;
  setHeader: ({
    toChangeHeader,
    toChangeBackgroundColor,
    hasNudge,
    activeSlideIndex,
  }: {
    toChangeHeader?: StrapiComponentType.Partial.Header;
    toChangeBackgroundColor?: string;
    hasNudge?: boolean;
    activeSlideIndex?: number;
  }) => void;
  overrideGrowthbookVariants: (variants?: Record<string, GrowthBookType.ContentVariants>) => void;
}

export const AppContext = createContext<AppContextType>({
  defaultQuery: "",
  header: DEFAULT_HEADER,
  backgroundColor: "transparent",
  defaultDomain: "",
  pageSliderData: {},
  growthBook: {},
  setProfile: () => {},
  setProfileImageUrl: () => {},
  setHeader: () => {},
  overrideGrowthbookVariants: () => {},
});
